import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmInput } from '@spartan-ng/helm/input';
import { HlmLabel } from '@spartan-ng/helm/label';

import { DetailGeneralFormGroup } from '../module-detail-form-groups.types';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { LabelRequiredDirective } from '@shared/directives/label-required.directive';

@Component({
  selector: 'app-detail-general',
  imports: [ReactiveFormsModule, HlmInput, HlmFieldImports, HlmLabel, LabelRequiredDirective],
  templateUrl: './detail-general.component.html',
})
export class DetailGeneralComponent {
  readonly form = input.required<DetailGeneralFormGroup>();
}
